import { render, staticRenderFns } from "./checkout-payment.vue?vue&type=template&id=4f4d6421&scoped=true&"
import script from "./checkout-payment.vue?vue&type=script&lang=js&"
export * from "./checkout-payment.vue?vue&type=script&lang=js&"
import style0 from "./checkout-payment.vue?vue&type=style&index=0&id=4f4d6421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d6421",
  null
  
)

export default component.exports